export default {
  login: {
    login: '登錄',
    account: '帳號',
    password: '密碼',
    remember: '記住密碼',
    forget: '忘記密碼',
    privacy_policy: '隱私政策',
    title: 'STAY 管理登入頁面'
  },
  lang: {
    ko: '한국인',
    ja: '日本語',
    zh: '中文(简)',
    'zh-Hant': '中文(繁)',
    en: 'English'
  },
  tip: {
    emptyData: '暫無資料',
    login: '帳號和密碼不能為空',
    success: '操作成功',
    fail: '操作失敗',
    tip: '提示',
    logout: '確定是否登出?',
    yes: '確定',
    no: '取消'
  },
  date: {
    week: {
      0: '日',
      1: '一',
      2: '二',
      3: '三',
      4: '四',
      5: '五',
      6: '六'
    }
  },
  header: {
    areaGuide: '區域指南',
    modelCourses: '示範路線',
    travelGuide: '旅遊指南',
    tickets: '票務',
    areaGuideDescription: '每個地區都有自己的故事',
    modelCoursesDescription: '為每種旅行風格定制的路線',
    travelGuideDescription: '來自遊客的真實體驗',
    accessMap: '訪問地圖',
    accessMapDescription: '從主要城市到這裡的方法',
    accessMapTitle: '主要城市訪問',
    accessCities: {
      tokyo: {
        name: '從東京',
        description: 'JR・近鐵特急',
        time: '約3小時'
      },
      kyoto: {
        name: '從京都',
        description: '近鐵特急',
        time: '約2小時30分鐘'
      },
      osaka: {
        name: '從大阪',
        description: '近鐵特急',
        time: '約2小時'
      },
      nagoya: {
        name: '從名古屋',
        description: '近鐵特急',
        time: '約1小時30分鐘'
      }
    }
  },
  footer: {
    termsOfService: '使用條款',
    privacyPolicy: '隱私政策',
    specifiedCommercialTransactions: '特定商業交易法',
    contact: '聯絡我們',
    address: '〒517-0011 三重縣鳥羽市鳥羽1-2-3',
    copyright: '© 近畿鐵道'
  },
  article: {
    aboutTheCourse: '關於課程',
    author: '作者',
    schedule: '行程安排',
    recommendedPoints: '推薦要點',
    home: '首頁',
    regionalIntroduction: '區域介紹',
    iseCity: '伊勢市',
    iseshi: '伊勢市',
    iseDescription: '一個圍繞伊勢神宮繁榮的歷史小鎮，日本人民的心靈聖地。',
    travelGuide: '旅遊指南',
    iseSightseeingGourmetGuide: '伊勢觀光美食指南',
    mustSeeSpots: '必看景點',
    relatedArticles: '相關文章',
    touristGuide: '旅遊指南',
    basicGuideToVisitingIseJingu: '參拜伊勢神宮的基本指南',
    traveler: '旅行者',
    showMore: '顯示更多'
  },
  home: {
    learnMore: '了解更多'
  },
  share: {
    activityCategory: {
      RAILWAY_TICKET: '鐵路票務',
      AIRPORT_TRANSPORTATION: '機場交通',
      SHINKANSEN: '新幹線',
      EXPRESS_BUS: '高速巴士',
      BUS_TOUR: '巴士觀光',
      CRUISES: '遊船',
      RENTAL_CAR: '租車',
      CHARTER: '包車',
      ATTRACTION: '景點',
      THEME_PARK: '主題樂園',
      MUSEUM_GALLERY: '博物館 / 美術館',
      AQUARIUM_ZOO: '水族館 / 動物園',
      TEMPLES_SHINES: '寺廟 / 神社',
      TOWER_BUILDING: '塔樓建築',
      JAPANESE_RESTAURANT: '日式餐廳',
      WESTERN_RESTAURANT: '西式餐廳',
      CHINESE_RESTAURANT: '中式餐廳',
      OTHER_RESTAURANT: '其他餐廳',
      DESSERT_BEVERAGE: '甜品飲品',
      SIGHTSEEING_TOUR: '觀光遊覽',
      MARINE_SPORTS: '水上運動',
      OUTDOOR_ACTIVITIES: '戶外活動',
      ONSEN: '溫泉',
      SPA_MASSAGE: '水療按摩',
      JAPANESE_CULTURAL_EXPERIENCE: '日本文化體驗',
      JAPANESE_CRAFT_EXPERIENCE: '日本工藝體驗',
      JAPANESE_COOKING_EXPERIENCE: '日本料理體驗',
      OTHER_EXPERIENCE: '其他體驗',
      HOTEL: '酒店',
      RYOKAN: '旅館',
      VACATION_RENTAL: '度假民宿',
      BUNDLE: '套票',
      PASS: '通票',
      OTHERS: '其他'
    }
  }
};
